export default __webpack_public_path__ + "static/12_Pig-ab9c2a6bf5a7a221ff7ea921297e01c4.png";